import { ElementRef, ForwardedRef, forwardRef } from 'react';
import * as Combobox from '@givebutter/primitives/combobox';
import { twMerge } from 'tailwind-merge';

interface FilterComboboxItemsProps extends Combobox.ComboboxItemsProps {}

const FilterComboboxItems = forwardRef(
    (
        { className, ...rest }: FilterComboboxItemsProps,
        forwardedRef: ForwardedRef<ElementRef<typeof Combobox.Items>>,
    ) => {
        return (
            <Combobox.Items
                className={twMerge(className, '-mx-2 text-sm font-medium')}
                ref={forwardedRef}
                {...rest}
            />
        );
    },
);

export { FilterComboboxItems };
